import React, { FC, ReactNode } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const ButtonTooltip: FC<{
  title: string;
  isShow: boolean;
  children: ReactNode;
  placement?: "right" | "top" | "bottom" | "left";
  className?: string;
}> = ({ title, isShow, children, className, placement = "left" }) => {
  return (
    <OverlayTrigger
      placement={placement}
      overlay={
        isShow ? <Tooltip id="tooltip-disabled">{title}</Tooltip> : <></>
      }
    >
      <span className={"d-inline-block " + className}>{children}</span>
    </OverlayTrigger>
  );
};

export default ButtonTooltip;
